import { AppLayout } from '@/routes/AppLayout.comp.tsx';
import { BareLayout } from '@/routes/BareLayout.comp.tsx';
import { RootLayout } from '@/routes/RootLayout.comp.tsx';
import { routesUtil } from '@/views/routes/utils/routes.util.ts';

export const createAppRoutes = routesUtil.createAppRoutes;

export const appRoutes = routesUtil.createAppRoutes({
  appLayout: <AppLayout />,
  bareLayout: <BareLayout />,
  rootLayout: <RootLayout />,
});
